import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface IniciarViajeModel {
    idViajeEAD: number;
}
type Entity = IniciarViajeModel;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un IniciarViaje
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        idViajeEAD: validation.required
    };
    return validation.getErrors(rules, x);
}


/**
* Modal de edición para un IniciarViaje
*/
export class IniciarViajeEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    idUsuario = (props: Props) => observeResource(resources.User.getIdUsuario);
    viajesPosibles = createSelectorRx(this.idUsuario, idUsuario => observeResource(resources.ViajeEAD.ObtenerPosiblesInicioApp, idUsuario));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const viajes = this.viajesPosibles(this.props);
        const Viaje = getField(selectores.ViajeEAD);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Iniciar viaje de EAD en este dispositivo"
            >

                <Viaje field="idViajeEAD" items={viajes} label="Viaje de EAD" />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/iniciar.tsx